var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('a',{staticClass:"text-decoration-none",attrs:{"href":_vm.linkType + ':' + _vm.value},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }